import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  query,
  where,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "../firebase";
import TextInputComponent from "../component/TextInputComponent";
import SecondTextInputComponent from "../component/SecondTextInputComponent";
import LoadingComponent from "../component/LoadingComponent";

const AdmissionStudent = () => {
  const [studied, setStudied] = useState("");
  const [countData, setCountData] = useState("");
  const [studiedRoman, setStudiedRoman] = useState("");
  const [formNumber, setFormNumber] = useState("");
  const [newAdmission, setNewAdmission] = useState("");
  const [admissionDate, setAdmissionDate] = useState("");
  const [studentIdNumber, setStudentIdNumber] = useState("");
  const [category, setCategory] = useState("");
  const [studentType, setStudentType] = useState("");
  const [rte, setRte] = useState("");
  const [boardType, setBoardType] = useState("");
  const [stream, setStream] = useState("");
  const [classSection, setClassSection] = useState("");
  const [studentRollNumber, setStudentRollNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [fathersName, setFathersName] = useState("");
  const [mothersName, setMothersName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailId, setEmailId] = useState("");
  const [bloodGroup, setBloodGroup] = useState("");
  const [religion, setReligion] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [nationality, setNationality] = useState("");
  const [physicalType, setPhysicalType] = useState("");
  const [studentPrevSchoolName, setStudentPrevSchoolName] = useState("");
  const [studentPrevTc, setStudentPrevTc] = useState("");
  const [studentPrevTcNumber, setStudentPrevTcNumber] = useState("");
  const [studentLeavingCertificate, setStudentLeavingCertificate] =
    useState("");
  const [studentAdmitClass, setStudentAdmitClass] = useState("");
  const [house, setHouse] = useState("");
  const [csrTag, setCsrTag] = useState("");
  const [admissionFee, setAdmissionFee] = useState("");
  const [admissionFeeCash, setAdmissionFeeCash] = useState("");
  const [annualFee, setAnnualFee] = useState("");
  const [annualFeeCash, setAnnualFeeCash] = useState("");
  const [activityFee, setActivityFee] = useState("");
  const [activityFeeCash, setActivityFeeCash] = useState("");
  const [examFee, setExamFee] = useState("");
  const [examFeeCash, setExamFeeCash] = useState("");
  const [tuitionFee, setTuitionFee] = useState("");
  const [tuitionFeeCash, setTuitionFeeCash] = useState("");
  const [scienceFee, setScienceFee] = useState("");
  const [scienceFeeCash, setScienceFeeCash] = useState("");
  const [computerFee, setComputerFee] = useState("");
  const [computerFeeCash, setComputerFeeCash] = useState("");
  const [sessionFee, setSessionFee] = useState("");
  const [sessionFeeCash, setSessionFeeCash] = useState("");
  const [permanentAddressLine, setPermanentAddressLine] = useState("");
  const [permanentAreaLocality, setPermanentAreaLocality] = useState("");
  const [permanentApartmentHouse, setPermanentApartmentHouse] = useState("");
  const [permanentZip, setPermanentZip] = useState("");
  const [permanentCity, setPermanentCity] = useState("");
  const [permanentState, setPermanentState] = useState("");
  const [permanentCountry, setPermanentCountry] = useState("");
  const [correspondenceAddressLine, setCorrespondenceAddressLine] =
    useState("");
  const [correspondenceAreaLocality, setCorrespondenceAreaLocality] =
    useState("");
  const [correspondenceApartment, setCorrespondenceApartment] = useState("");
  const [correspondenceZip, setCorrespondenceZip] = useState("");
  const [correspondenceCity, setCorrespondenceCity] = useState("");
  const [correspondenceState, setCorrespondenceState] = useState("");
  const [correspondenceCountry, setCorrespondenceCountry] = useState("");
  //
  const [loading, setLoading] = useState(false);

  // validate error start

  let [numberOfErrors, setNumberOfErrors] = useState(0);
  const [studentIdNumberError, setStudentIdNumberError] = useState("");
  const [emailIdError, setEmailIdError] = useState("");
  const [aadhaarNumberError, setAadhaarNumberError] = useState("");

  // validate error end

  const Class = [
    { num: 1, val: "I" },
    { num: 2, val: "II" },
    { num: 3, val: "III" },
    { num: 4, val: "IV" },
    { num: 5, val: "V" },
    { num: 6, val: "VI" },
    { num: 7, val: "VII" },
    { num: 8, val: "VIII" },
    { num: 9, val: "IX" },
    { num: 10, val: "X" },
    { num: 11, val: "XI" },
    { num: 12, val: "XII" },
  ];

  useEffect(() => {
    if (studied.length > 0 && studied !== "null") {
      const temp = Class.find((elem) => elem.num === parseInt(studied)).val;
      setStudiedRoman(temp);
    } else if (studied === "null") {
      setStudiedRoman("Please Select Standard");
    }
  }, [studied]);

  useEffect(() => {
    const dataCount = async () => {
      const coll = collection(db, "admissionStudentList");
      const query_ = query(coll);
      const snapshot = await getCountFromServer(query_);
      setCountData(snapshot.data().count);
    };
    dataCount();
  }, []);
  // console.log(countData);

  const handleOnAdmissionStudent = async () => {


    if (!studentIdNumber) {
      setStudentIdNumberError("Student Id Number can't be empty !");
      setNumberOfErrors(numberOfErrors++);
    } else setStudentIdNumberError("");

    if (!emailId) {
      setEmailIdError("Enail Id can't be empty !");
      setNumberOfErrors(numberOfErrors++);
    } else setEmailIdError("");

    if (!aadhaarNumber) {
      setAadhaarNumberError("Aadhaar Numbercan't be empty !");
      setNumberOfErrors(numberOfErrors++);
    } else setAadhaarNumberError("");

    if (numberOfErrors === 0) {
      setLoading(true);
      await addDoc(collection(db, "admissionStudentList"), {
        fullName,
        formNumber,
        newAdmission,
        admissionDate,
        admissionNumber: countData + 1,
        studentIdNumber,
        category,
        studentType,
        rte,
        boardType,
        stream,
        studied,
        classSection,
        class: studied + classSection,
        studentRollNumber,
        gender,
        dateOfBirth,
        fathersName,
        mothersName,
        phoneNumber,
        emailId,
        bloodGroup,
        religion,
        aadhaarNumber,
        nationality,
        physicalType,
        studentPrevSchoolName,
        studentPrevTc,
        studentPrevTcNumber,
        studentLeavingCertificate,
        studentAdmitClass,
        house,
        csrTag,
        admissionFee,
        admissionFeeCash,
        annualFee,
        annualFeeCash,
        examFee,
        examFeeCash,
        tuitionFee,
        tuitionFeeCash,
        scienceFee,
        scienceFeeCash,
        computerFee,
        computerFeeCash,
        activityFee,
        activityFeeCash,
        sessionFee,
        sessionFeeCash,
        permanentAddressLine,
        permanentApartmentHouse,
        permanentAreaLocality,
        permanentCity,
        permanentCountry,
        permanentState,
        permanentZip,
        correspondenceAddressLine,
        correspondenceApartment,
        correspondenceAreaLocality,
        correspondenceCity,
        correspondenceCountry,
        correspondenceState,
        correspondenceZip,
      }).then(() => {
        setLoading(false);
        // alert("Application form submitted successfully")
        setTimeout(() => {
          window.location.reload(false);
        }, 3000);
      });
    }
  };

  return (
    <div>
      <div className="pt-10 pl-5 pr-5 "></div>
      <div className="w-full p-5 text-gray-700">
        <div className="grid grid-cols-7 gap-4">
          <div className="justify-items-center items-center">
            <img src="../assets/sail.png" alt="pic" className="h-32 w-32" />
          </div>
          <div className="mb-2 text-center w-full col-span-5">
            <div className="mb-1 ">
              <span className="font-bold  text-3xl ">
                BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
              </span>
            </div>
            <div className="grid grid-cols-9 gap-4">
              <div className="mb-1 col-span-5 ml-10">
                <span className="text-xl ">BOKARO STEEL CITY, JHARKHAND</span>
              </div>
              <div className="mb-1 col-span-3">
                <span className="text-xl ">
                  CBSE Affiliation NO. :- 3430077
                </span>
              </div>
            </div>
            <div className="mb-1 mt-5">
              <span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
                STUDENT ADMISSION FORM - <span>{studiedRoman}</span>/
                {classSection.length > 0 ? <span>{classSection}</span> : <></>}
              </span>
            </div>
          </div>
          <div className="justify-items-center items-center">
            <img src="../assets/as_logo.png" alt="pic" className="h-32 w-32" />
          </div>
        </div>
        <div className="w-full mt-5">
          <div className="grid grid-cols-3 gap-4 pl-10">
            <TextInputComponent
              inputValue={formNumber}
              inputPlaceHolder="form NO."
              inputType="text"
              onChangeValue={setFormNumber}
              label="Form NO."
            />
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">New Admission</h2>
              <select
                value={newAdmission}
                onChange={(e) => {
                  setNewAdmission(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>
            </div>
            <TextInputComponent
              inputValue={admissionDate}
              inputPlaceHolder="Admission Date"
              inputType="date"
              onChangeValue={setAdmissionDate}
              label="Admission Date"
            />
          </div>

          <div className="grid grid-cols-3 gap-4 pl-10">
            <div className="mx-2 mt-3">
              <h2 className="block text-left">Admission Number</h2>
              <div className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">{countData+1}</div>
            </div>

          

            <TextInputComponent
              inputValue={studentIdNumber}
              inputPlaceHolder="Student Id"
              inputType="text"
              onChangeValue={setStudentIdNumber}
              label="Student Id"
              inputError={studentIdNumberError}
            />
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Category</h2>
              <select
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="Schedule Caste">Schedule Caste</option>
                <option value="Schedule Tribe">Schedule Tribe</option>
                <option value="General">General</option>
                <option value="OBC I">OBC I</option>
                <option value="OBC II">OBC II</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4 pl-10">
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Class</h2>
              <select
                onChange={(e) => setStudied(e.target.value)}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="null">Please Select Standard</option>
                {Class.map((item, index) => (
                  <option value={item.num} key={index}>
                    {item.num}
                  </option>
                ))}
              </select>
            </div>

            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Section</h2>
              <select
                value={classSection}
                onChange={(e) => {
                  setClassSection(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="null"> select</option>
                <option value="A">A</option>
                <option value="B">B</option>
                <option value="C">C</option>
                <option value="D">D</option>
                <option value="E">E</option>
                <option value="F">F</option>
              </select>
            </div>
            <TextInputComponent
              inputValue={studentRollNumber}
              inputPlaceHolder="Roll Number"
              inputType="number"
              onChangeValue={setStudentRollNumber}
              label="Roll Number"
              inputError={studentIdNumberError}
            />
          </div>

          <div className="grid grid-cols-3 gap-4 pl-10">
            <TextInputComponent
              inputValue={fullName}
              inputPlaceHolder="Full Name"
              inputType="text"
              onChangeValue={setFullName}
              label="Name of Pupil"
            />
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Gender</h2>
              <select
                value={gender}
                onChange={(e) => {
                  setGender(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="MALE">MALE</option>
                <option value="FEMALE">FEMALE</option>
              </select>
            </div>
            <TextInputComponent
              inputValue={dateOfBirth}
              inputPlaceHolder="date of birth"
              inputType="date"
              onChangeValue={setDateOfBirth}
              label="Date of birth"
            />
          </div>
          <div className="grid grid-cols-3 gap-4 pl-10">
            <TextInputComponent
              inputValue={fathersName}
              inputPlaceHolder="Father's Name"
              inputType="text"
              onChangeValue={setFathersName}
              label="Father's Name"
            />

            <TextInputComponent
              inputValue={mothersName}
              inputPlaceHolder="Mother's Name"
              inputType="text"
              onChangeValue={setMothersName}
              label="Mother's Name"
            />

            <TextInputComponent
              inputValue={phoneNumber}
              inputPlaceHolder="Phone Number"
              inputType="text"
              onChangeValue={setPhoneNumber}
              label="Phone Number"
            />
          </div>
          <div className="grid grid-cols-3 gap-4 pl-10">
            <TextInputComponent
              inputValue={emailId}
              inputPlaceHolder="Email-Id"
              inputType="email"
              onChangeValue={setEmailId}
              inputError={emailIdError}
              label="Email Id"
            />
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Blood Group</h2>
              <select
                value={bloodGroup}
                onChange={(e) => {
                  setBloodGroup(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="A+">A+</option>
                <option value="A-">A-</option>
                <option value="B+">B+</option>
                <option value="B-">B-</option>
                <option value="O+">O+</option>
                <option value="O-">O-</option>
                <option value="AB+">AB+</option>
                <option value="AB-">AB-</option>
              </select>
            </div>
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Religion</h2>
              <select
                value={religion}
                onChange={(e) => {
                  setReligion(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="HINDU">HINDU</option>
                <option value="MUSLIM">MUSLIM</option>
                <option value="SIKH">SIKH</option>
                <option value="CRISTIANE">CRISTIANE</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 pl-10">
            <TextInputComponent
              inputValue={aadhaarNumber}
              inputPlaceHolder="Aadhaar Number"
              inputType="text"
              onChangeValue={setAadhaarNumber}
              inputError={aadhaarNumberError}
              label="Aadhaar Number"
            />
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Nationality</h2>
              <select
                value={nationality}
                onChange={(e) => {
                  setNationality(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="INDIAN">INDIAN</option>
              </select>
            </div>
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Stream</h2>
              <select
                value={stream}
                onChange={(e) => {
                  setStream(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="ARTS">ARTS</option>
                <option value="COMMERCE">COMMERCE</option>
                <option value="SCIENCE">SCIENCE</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-4 pl-10">
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Student Type</h2>
              <select
                value={studentType}
                onChange={(e) => {
                  setStudentType(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="NBSL">NBSL</option>
                <option value="ATPAR">ATPAR</option>
                <option value="BSL">BSL</option>
              </select>
            </div>
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">RTE</h2>
              <select
                value={rte}
                onChange={(e) => {
                  setRte(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>
            </div>
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Board Type</h2>
              <select
                value={boardType}
                onChange={(e) => {
                  setBoardType(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="CBSE">CBSE</option>
              </select>
            </div>
          </div>

          <div className="">
            <div className="w-full p-5">
              <div className="mb-2 text-left pl-10">
                <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                  Permanent Address
                </span>
              </div>

              <div className="grid grid-cols-3 gap-4 pl-10">
                <TextInputComponent
                  inputValue={permanentAddressLine}
                  inputPlaceHolder="Address Line 1"
                  inputType="text"
                  onChangeValue={setPermanentAddressLine}
                  label="Address Line 1"
                />

                <TextInputComponent
                  inputValue={permanentAreaLocality}
                  inputPlaceHolder="Area/Road/Locality"
                  inputType="text"
                  onChangeValue={setPermanentAreaLocality}
                  label="Area/Road/Locality:"
                />

                <TextInputComponent
                  inputValue={permanentApartmentHouse}
                  inputPlaceHolder="Apartment"
                  inputType="text"
                  onChangeValue={setPermanentApartmentHouse}
                  label="Apartment"
                />

                <TextInputComponent
                  inputValue={permanentState}
                  inputPlaceHolder="State"
                  inputType="text"
                  onChangeValue={setPermanentState}
                  label="State"
                />

                <TextInputComponent
                  inputValue={permanentZip}
                  inputPlaceHolder="Zip Code"
                  inputType="text"
                  onChangeValue={setPermanentZip}
                  label="Zip Code"
                />

                <TextInputComponent
                  inputValue={permanentCity}
                  inputPlaceHolder="City"
                  inputType="text"
                  onChangeValue={setPermanentCity}
                  label="City"
                />
              </div>
            </div>

            <div className="w-full p-5">
              <div className="mb-2 text-left pl-10">
                <span className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4 text-xl">
                  Correspondence Address
                </span>
              </div>

              <div className="grid grid-cols-3 gap-4 pl-10">
                <TextInputComponent
                  inputValue={correspondenceAddressLine}
                  inputPlaceHolder="Address Line 1"
                  inputType="text"
                  onChangeValue={setCorrespondenceAddressLine}
                  label="Address Line 1"
                />

                <TextInputComponent
                  inputValue={correspondenceAreaLocality}
                  inputPlaceHolder="Area/Road/Locality"
                  inputType="text"
                  onChangeValue={setCorrespondenceAreaLocality}
                  label="Area/Road/Locality:"
                />

                <TextInputComponent
                  inputValue={correspondenceApartment}
                  inputPlaceHolder="Apartment"
                  inputType="text"
                  onChangeValue={setCorrespondenceApartment}
                  label="Apartment"
                />

                <TextInputComponent
                  inputValue={correspondenceState}
                  inputPlaceHolder="State"
                  inputType="text"
                  onChangeValue={setCorrespondenceState}
                  label="State"
                />

                <TextInputComponent
                  inputValue={correspondenceZip}
                  inputPlaceHolder="Zip Code"
                  inputType="text"
                  onChangeValue={setCorrespondenceZip}
                  label="Zip Code"
                />

                <TextInputComponent
                  inputValue={correspondenceCity}
                  inputPlaceHolder="City"
                  inputType="text"
                  onChangeValue={setCorrespondenceCity}
                  label="City"
                />
              </div>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4 pl-10">
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Physical Type</h2>
              <select
                value={physicalType}
                onChange={(e) => {
                  setPhysicalType(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>
            </div>

            <TextInputComponent
              inputValue={studentPrevSchoolName}
              inputPlaceHolder="Student Prev School Name"
              inputType="text"
              onChangeValue={setStudentPrevSchoolName}
              label="Student Prev School Name"
            />

            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Student Prev Tc</h2>
              <select
                value={studentPrevTc}
                onChange={(e) => {
                  setStudentPrevTc(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>
            </div>

            <TextInputComponent
              inputValue={studentPrevTcNumber}
              inputPlaceHolder="Student Prev Tc Number"
              inputType="text"
              onChangeValue={setStudentPrevTcNumber}
              label="Student Prev Tc Number"
            />

            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">SLC</h2>
              <select
                value={studentLeavingCertificate}
                onChange={(e) => {
                  setStudentLeavingCertificate(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="YES">YES</option>
                <option value="NO">NO</option>
              </select>
            </div>
            <div className="mx-2 mt-3">
              <h2 className="block text-left md:mb-0">Student Admit Class</h2>
              <select
                value={studentAdmitClass}
                onChange={(e) => {
                  setStudentAdmitClass(e.target.value);
                }}
                className={`w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none `}
              >
                <option value="select"> select</option>
                <option value="CLASS 1">CLASS 1</option>
                <option value="CLASS 2">CLASS 2</option>
                <option value="CLASS 3">CLASS 3</option>
                <option value="CLASS 4">CLASS 4</option>
                <option value="CLASS 5">CLASS 5</option>
                <option value="CLASS 6">CLASS 6</option>
                <option value="CLASS 7">CLASS 7</option>
                <option value="CLASS 8">CLASS 8</option>
                <option value="CLASS 9">CLASS 9</option>
                <option value="CLASS 10">CLASS 10</option>
                <option value="CLASS 11">CLASS 11</option>
                <option value="CLASS 12">CLASS 12</option>
              </select>
            </div>
          </div>

          <div className="grid grid-cols-4 gap-4 mt-5">
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-3/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  House
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={house}
                  onChange={(e) => {
                    setHouse(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="BIRSA">BIRSA</option>
                  <option value="SHIVA JI">SHIVA JI</option>
                  <option value="RAJENDRA">RAJENDRA</option>
                  <option value="TIGORE">TIGORE</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-1/3">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  CSR Tag
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={csrTag}
                  onChange={(e) => {
                    setCsrTag(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-3/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Admission Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={admissionFee}
                  onChange={(e) => {
                    setAdmissionFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={admissionFeeCash}
                  onChange={(e) => {
                    setAdmissionFeeCash(e.target.value);
                  }}
                  type="text"
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-3/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Anuual Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={annualFee}
                  onChange={(e) => {
                    setAnnualFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={annualFeeCash}
                  onChange={(e) => {
                    setAnnualFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-2/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Activity Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={activityFee}
                  onChange={(e) => {
                    setActivityFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={activityFeeCash}
                  onChange={(e) => {
                    setActivityFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-3/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Exam Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={examFee}
                  onChange={(e) => {
                    setExamFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={examFeeCash}
                  onChange={(e) => {
                    setExamFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-2/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Tuition Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={tuitionFee}
                  onChange={(e) => {
                    setTuitionFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={tuitionFeeCash}
                  onChange={(e) => {
                    setTuitionFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-3/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Science Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={scienceFee}
                  onChange={(e) => {
                    setScienceFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={scienceFeeCash}
                  onChange={(e) => {
                    setScienceFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-2/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Computer Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={computerFee}
                  onChange={(e) => {
                    setComputerFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={computerFeeCash}
                  onChange={(e) => {
                    setComputerFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
          </div>
          <div className="grid grid-cols-4 gap-4">
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-3/5">
                <label
                  className="block  md:text-center mb-1 md:mb-0 "
                  htmlFor="inline-full-name"
                >
                  Session Fee
                </label>
              </div>
              <div className="md:w-3/5">
                <select
                  value={sessionFee}
                  onChange={(e) => {
                    setSessionFee(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                >
                  <option value="select"> select</option>
                  <option value="YES">YES</option>
                  <option value="NO">NO</option>
                </select>
              </div>
            </div>
            <div className="md:flex md:items-center mb-6 ">
              <div className="md:w-full">
                <input
                  value={sessionFeeCash}
                  onChange={(e) => {
                    setSessionFeeCash(e.target.value);
                  }}
                  className="w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="text-center ease-in-out duration-300 pb-6 ">
          <button
            onClick={handleOnAdmissionStudent}
            className="w-24 text-white text-xl h-10 text-center font-semibold rounded-md  bg-[#1273DE] hover:bg-[#117BEF] active:bg-[#117BEF] focus:outline-none focus:ring focus:ring-[#117BEF]"
          >
            Submit
          </button>
        </div>
      </div>
      {loading && <LoadingComponent label="Loading..." />}
    </div>
  );
};

export default AdmissionStudent;
